import React from 'react';
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const ServiceList = [
    {
        icon: '1',
        title: 'Training',
        description: 'Attend powerful workshops and flagship programs designed for impact. Each training is packed with practical tools to transform life, business, and income.'
    },
    {
        icon: '2',
        title: 'Consultation',
        description: 'Get personalized 1-on-1 consulting tailored to your life, business, and income goals. Gain clarity, strategy, and confidence to take action and grow fast.'
    },
    {
        icon: '3',
        title: 'Speaking',
        description: 'Book Jahid Hasan for high-impact keynotes on entrepreneurship, mindset, and wealth. Inspire, educate, and activate your audience with real-world insights.'
    },
    {
        icon: '4',
        title: 'Digital Courses',
        description: 'Access expert-designed, result-driven courses anytime, anywhere. Affordable, actionable, and perfect for beginners and fast learners alike.'
    },
    {
        icon: '5',
        title: 'Content',
        description: 'Learn through bite-sized videos, tools, and frameworks built for real results. Our content is simple, strategic, and designed to level up your mindset and skills.'
    },
    {
        icon: '6',
        title: 'Community',
        description: 'Join a purpose-driven community of entrepreneurs, professionals, and learners. Grow together through networking, support, and collaboration.'
    },
    {
        icon: '7',
        title: 'Affiliates',
        description: 'Earn while you grow by promoting PWU programs as an affiliate partner. Empower others and build your own income through impact.'
    },
    {
        icon: '8',
        title: 'Podcast Request',
        description: "Invite Jahid Hasan to your podcast for powerful conversations on business, mindset, leadership, and impact. Let's create value together and inspire your audience."
    },
]

const ServiceFour = ({textAlign, serviceStyle}) => {
    return (
        <div className="row row--15 service-wrapper">
              {ServiceList.map( (val , i) => (
                <div className="col-lg-3 col-md-6 col-sm-6 col-12" key={i}>
                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <div className={`service ${serviceStyle} ${textAlign}`}>
                            <div className="icon">
                                <div className="line"></div>
                                {val.icon}
                            </div>
                            <div className="content">
                                <h4 className="title"><Link to="#service" dangerouslySetInnerHTML={{__html: val.title}}></Link></h4>
                                <p className="description b1 color-gray mb--0" dangerouslySetInnerHTML={{__html: val.description}}></p>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default ServiceFour;